export const CURRENCY_SYMBOLS: {
  [key in CurrencyKeys]: {
    id: CurrencyKeys
    symbol: string
  }
} = {
  USD: {
    id: 'USD',
    symbol: '$'
  },
  INR: {
    id: 'INR',
    symbol: '₹'
  }
}
